module.exports = __webpack_public_path__ + "media/icon/arrow-drop-up-df772610.svg";